import {
  buttonClasses,
  buttonIconClasses,
} from "@/design-system/Button/Button";
import { cn } from "@/lib/utils";
import { ANDROID_APP_URL } from "@/settings";
import { useTranslation } from "@repo/shared/i18n";

import { AndroidIcon } from "./PlatformIcons";

/** The Android beta's Play listing, as a primary button. */
export const AndroidBetaLink = ({
  stretch,
  className,
}: {
  stretch?: boolean;
  className?: string;
}) => {
  const { t } = useTranslation("appLanding");
  return (
    <a
      href={ANDROID_APP_URL}
      target="_blank"
      rel="noreferrer"
      className={buttonClasses({
        variant: "primary",
        size: "medium",
        stretch,
        className: cn("font-semibold whitespace-nowrap", className),
      })}
    >
      <span className={buttonIconClasses({ size: "medium" })}>
        <AndroidIcon />
      </span>
      <span>{t("androidBeta.cta")}</span>
    </a>
  );
};
